import { ReactNode } from "react";
import { Site } from "src/sites/types";
export interface ResetFormModalContents {
  title: string;
  description: ReactNode;
  confirm: string;
  cancel: string;
}
export enum ClaimSubmittedStatus {
  LOADING = "loading",
  SUCCESS = "success",
  ERROR = "error",
}
export enum LineOfBusiness {
  WORKERS_COMPENSATION = "WORKERS_COMPENSATION",
  CARGO = "CARGO",
  IPL = "IPL",
  ATOZ = "ATOZ",
}

export interface SimLinkClaimModel {
  amazonClaimReferenceId?: string;
  associateAlias?: string;
  associateEmployeeId?: string;
  associateFirstName?: string;
  associateLastName?: string;
  code?: string;
  incidentDate?: string;
  incidentSiteName?: string;
  name?: string;
  notificationAliasList?: string[];
  notificationWebhook?: string;
}

export interface SimLinkClaimAdditionalFields {
  amazonClaimReferenceId: string;
  incidentSite?: Site | null;
  associateHomeSite?: Site | null;
}
